export type OfferOwnerPagesTranslation = {
  previewDialog: {
    button: {
      close: string;
    };
    title: string;
  };
  table: {
    button: {
      add: string;
    };
    filters: {
      fullTextSearchInput: string;
      user: string;
    };
    head: {
      createdAt: string;
      createdBy: string;
      email: string;
      user: string;
    };
    row: {
      actions: {
        confirmDelete: string;
        delete: string;
        preview: string;
      };
    };
  };
  uploadDialog: {
    button: {
      cancel: string;
      submit: string;
    };
    form: {
      file: string;
      fileSelected: string;
      user: string;
    };
    hint: {
      upsertHint: string;
    };
    preview: {
      empty: string;
      title: string;
    };
    title: string;
  };
};

export const offerOwnerPagesTranslation: OfferOwnerPagesTranslation = {
  previewDialog: {
    button: {
      close: 'Zamknij',
    },
    title: 'Podgląd strony osobistej: {{name}}',
  },
  table: {
    button: {
      add: 'Dodaj stronę',
    },
    filters: {
      fullTextSearchInput: 'Szukaj po imieniu lub nazwisku',
      user: 'Użytkownik',
    },
    head: {
      createdAt: 'Data dodania',
      createdBy: 'Dodał(a)',
      email: 'E-mail',
      user: 'Użytkownik',
    },
    row: {
      actions: {
        confirmDelete: 'Na pewno usunąć stronę osobistą tego użytkownika?',
        delete: 'Usuń',
        preview: 'Podgląd',
      },
    },
  },
  uploadDialog: {
    button: {
      cancel: 'Anuluj',
      submit: 'Zapisz',
    },
    form: {
      file: 'Plik PDF',
      fileSelected: 'Wybrany plik: {{name}}',
      user: 'Użytkownik (właściciel procesu)',
    },
    hint: {
      upsertHint:
        'Jeden użytkownik = jedna strona osobista. Wgranie pliku dla użytkownika, który już ma stronę, zastąpi poprzednią.',
    },
    preview: {
      empty: 'Wgraj plik PDF, aby zobaczyć podgląd.',
      title: 'Podgląd PDF',
    },
    title: 'Nowa strona osobista',
  },
};
